import { useState } from 'react';
import { confirmConfigAdditionalAction } from '../../../../../services/suscription/configurations.service';
import { IAdditionalActions } from '../../../../../types/orders';
import { IProductConfigAdditionalActionConfirmDto } from '../../../../../types/product.configuration.types';
import {
  displayErrorNotification,
  displaySuccessNotification
} from '../../../../../utils/displayNudosStandardNotifications';
import BordOneToneIcon from '../../../../NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { NudosButton } from '../../../../NudosComponents';

import './EnrollmentStatusIndicator.scss';

interface IEnrollmentStatusIndicatorProps {
  enrollmentAction: IAdditionalActions;
  onConfirmEnrollment: () => Promise<void>;
}

export default function EnrollmentStatusIndicator({
  enrollmentAction: { confirmedAt: isConfirmed, uuid: enrollmentActionUuid },
  onConfirmEnrollment
}: IEnrollmentStatusIndicatorProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const statusText = isConfirmed ? 'Confirmado ●' : 'Sin confirmar ●';
  const statusClass = isConfirmed ? 'confirmed' : 'unconfirmed';

  const handleConfirmEnrollment = async () => {
    try {
      setIsSubmitting(true);
      const confirmBody: IProductConfigAdditionalActionConfirmDto = {
        uuid: enrollmentActionUuid
      };
      await confirmConfigAdditionalAction(confirmBody);
      displaySuccessNotification({
        customJSXMessage: <>Enrollment confirmado con éxito</>,
        duration: 3000
      });
      await onConfirmEnrollment();
    } catch {
      displayErrorNotification();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={`enrollmentStatusIndicatorContainer ${statusClass}`}>
      <div className="statusSection">
        <span>Estado del Enrollment: </span>
        <span className={`statusText ${statusClass}`}>{statusText}</span>
      </div>
      {!isConfirmed && (
        <NudosButton
          customClassName="confirmButton"
          customWidth="max-content"
          customHeight="20px"
          buttonText="Confirmar enrollment"
          handleClick={handleConfirmEnrollment}
          isButtonDisabled={isSubmitting}
          isButtonLoading={isSubmitting}
          buttonIcon={<BordOneToneIcon variant="checkCircle" standardSize={8} stroke="white" />}
          iconPosition="right"
        />
      )}
    </div>
  );
}
